import { take, fork, call, put } from 'redux-saga/effects'
import { END } from 'redux-saga'
import AuthActions from '../Redux/AuthRedux'

export function * baseListen (type, fetchSaga, api, token) {
  let action = yield take(type)
  while (action !== END) {
    if (token) {
      yield fork(fetchSaga, api, token, action)
    } else {
      yield fork(fetchSaga, api, action)
    }
    action = yield take(type)
  }
}

export function * baseFetchToken (api, data, getToken, successAction, failureAction) {
  try {
    const token = yield call(getToken)
    if (!token) {
      yield put(AuthActions.authLogout())
    } else {
      const res = yield call(api, token, data)
      if (!res.ok) {
        yield put(failureAction(res.data.message || 'Terjadi kesalahan, ulangi beberapa saat lagi'))
      } else {
        if (!res.data.error) {
          yield put(successAction(res.data.data))
        } else {
          yield put(failureAction(res.data.message))
        }
      }
    }
  } catch (e) {
    yield put(failureAction())
  }
}

export function * baseFetchTokenUpdate (api, data, getToken, successAction, failureAction) {
  try {
    const token = yield call(getToken)
    if (!token) {
      yield put(AuthActions.authLogout())
    } else {
      const res = yield call(api, token, data)
      if (!res.ok) {
        yield put(failureAction('Terjadi kesalahan, ulangi beberapa saat lagi'))
      } else {
        if (!res.data.error) {
          yield put(successAction(data))
        } else {
          yield put(failureAction(res.data.message))
        }
      }
    }
  } catch (e) {
    yield put(failureAction())
  }
}

export function * baseFetchNoToken (api, data, successAction, failureAction) {
  try {
    const res = yield call(api, data)
    if (!res.ok) {
      yield put(failureAction('Terjadi kesalahan, ulangi beberapa saat lagi'))
    } else {
      if (!res.data.error) {
        yield put(successAction(res.data.data))
      } else {
        yield put(failureAction(res.data.message))
      }
    }
  } catch (e) {
    yield put(failureAction())
  }
}

export function * baseFetchTokenFullResponse (api, data, getToken, successAction, failureAction) {
  try {
    const token = yield call(getToken)
    if (!token) {
      yield put(AuthActions.authLogout())
    } else {
      const res = yield call(api, token, data)
      if (!res.ok) {
        yield put(failureAction('Terjadi kesalahan, ulangi beberapa saat lagi'))
      } else {
        if (!res.data.error) {
          yield put(successAction(res.data))
        } else {
          yield put(failureAction(res.data.message))
        }
      }
    }
  } catch (e) {
    yield put(failureAction())
  }
}



// WEBPACK FOOTER //
// ./src/Sagas/BaseSaga.js